<p-table
  [columns]="columns"
  [paginator]="true"
  [rows]="10"
  [scrollable]="true"
  [showGridlines]="true"
  [stripedRows]="true"
  [style]="{ margin: '1rem' }"
  [value]="entries"
  #table
  size="small">
  <ng-template let-columns pTemplate="header">
    <tr>
      @for (col of columns; track col.field) {
        <th [pSortableColumn]="col.field" [width]="'200px'">
          {{ col.header | translate }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
    <tr>
      @for (col of columns; track col.field) {
        <th [width]="'200px'">
          <input (input)="table.filter($any($event.target).value, col.field, 'contains')" pInputText type="text" />
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-columns="columns" let-rowData pTemplate="body">
    <tr>
      @for (col of columns; track col.field) {
        <td [width]="'200px'">
          @switch (col.field.toLowerCase()) {
            @case ('fallid') {
              <a (click)="showCustomer(rowData, rowData[col.field])">{{ rowData[col.field] }}</a>
            }
            @case ('personalid') {
              <a (click)="showEmployee(rowData, rowData[col.field])">{{ rowData[col.field] }}</a>
            }
            @default {
              {{ rowData[col.field] }}
            }
            @case ('empfaengermitarbeiter') {
              @if (isArray(rowData[col.field])) {
                <ul>
                  @for (entry of rowData[col.field]; track $index) {
                    <li>
                      <a (click)="showEmployee(entry, entry['PersonalId'])">{{ entry['PersonalId'] }}</a>
                    </li>
                  }
                </ul>
              } @else {
                @if (rowData[col.field] && rowData[col.field]['PersonalId']) {
                  <a (click)="showEmployee(rowData[col.field], rowData[col.field]['PersonalId'])">
                    {{ rowData[col.field]['PersonalId'] }}
                  </a>
                }
              }
            }
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="showDetail" [header]="'JOBS.DETAIL' | translate" [modal]="true" [style]="{ width: '700px' }">
  <p-treeTable
    [columns]="[
      { field: 'name', header: 'Name' },
      { field: 'value', header: 'Value' },
    ]"
    [showGridlines]="true"
    [style]="{ 'overflow-x': 'visible' }"
    [value]="detail"
    styleClass="p-treetable-sm p-treetable-striped">
    <ng-template let-columns="columns" let-rowData="rowData" let-rowNode pTemplate="body">
      <tr>
        @for (col of columns; track col.field; let i = $index) {
          <td>
            @if (i === 0) {
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            }
            {{ rowData[col.field] }}
          </td>
        }
      </tr>
    </ng-template>
  </p-treeTable>
</p-dialog>
